import { proxy } from 'valtio';

export type TemplatePickerState = {
  /**
   * You MUST also update
   * `packages/analytics-frontend/src/event-schema/canvas-frontend.entities.ts` when
   * changing this!
   */
  openedFrom: 'board-creation' | 'empty-board-load' | 'toolbar';
};

export const defaultTemplatePickerState: TemplatePickerState = {
  openedFrom: 'toolbar',
};

export const currentTemplatePickerState: TemplatePickerState = proxy(
  defaultTemplatePickerState
);
